const getters = {
    language: state => state.app.language
};

export default getters;
